<template>
  <div class="wrapper">
    <div class="head">
      <h4>成员企业</h4>
    </div>
    <div class="iconleft"></div>
    <div class="iconright"></div>
    <van-swipe
      class="my-swipe"
      :autoplay="3000 * 60 * 24"
      indicator-color="#FF6A00"
    >
      <van-swipe-item>
        <div class="box">
          <div
            v-for="(i, index) in items[0]"
            :key="index"
            :class="`item item${index + 1}`"
            :style="{
              backgroundImage: `url(${i.cover})`
            }"
            @click="showModel(i)"
          >
            <div :class="current == i.id ? 'mask active' : 'mask'">
              <h4>{{ i.name }}</h4>
              <p>{{ i.desc }}</p>
            </div>
          </div>
        </div>
      </van-swipe-item>
      <van-swipe-item>
        <div class="box">
          <div
            v-for="(i, index) in items[1]"
            :key="index"
            :class="`item item${index + 7}`"
            :style="{
              backgroundImage: `url(${i.cover})`
            }"
            @click="showModel(i)"
          >
            <div :class="current == i.id ? 'mask active' : 'mask'">
              <h4>{{ i.name }}</h4>
              <p>{{ i.desc }}</p>
            </div>
          </div>
        </div>
      </van-swipe-item>
      <van-swipe-item>
        <div class="box">
          <div
            v-for="(i, index) in items[2]"
            :key="index"
            :class="`item item${index + 13}`"
            :style="{
              backgroundImage: `url(${i.cover})`
            }"
            @click="showModel(i)"
          >
            <div :class="current == i.id ? 'mask active' : 'mask'">
              <h4>{{ i.name }}</h4>
              <p>{{ i.desc }}</p>
            </div>
          </div>
        </div>
      </van-swipe-item>
      <van-swipe-item>
        <div class="box">
          <div
            v-for="(i, index) in items[3]"
            :key="index"
            :class="`item item${index + 19}`"
            :style="{
              backgroundImage: `url(${i.cover})`
            }"
            @click="showModel(i)"
          >
            <div :class="current == i.id ? 'mask active' : 'mask'">
              <h4>{{ i.name }}</h4>
              <p>{{ i.desc }}</p>
            </div>
          </div>
        </div>
      </van-swipe-item>
    </van-swipe>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { teamChines } from "@/util/text";
export default {
  data() {
    return {
      current: 0
    };
  },
  computed: {
    ...mapGetters({ language: "getType" }),
    title() {
      return this.language == "中文"
        ? "我们像在迷宫里寻找答案的小孩，要找到拼图的模块，但更要先通过模块去想象拼图最终的模样，并不断地去纠正。"
        : "Wandering for pieces to complete a puzzle, we trend with a vision reflections in mind.";
    },
    list() {
      return this.language == "中文" ? teamChines : teamChines;
    },
    items() {
      let res = [];
      this.list.forEach((item, index) => {
        if (!res[Math.floor(index / 6)]) {
          res[Math.floor(index / 6)] = [];
        }
        res[Math.floor(index / 6)].push(item);
      });
      return res;
    }
  },

  methods: {
    showModel(item) {
      if (item.url) {
        window.open(item.url);
      }
    }
  }
};
</script>

<style lang="less" scoped>
.wrapper {
  position: relative;
  width: 100%;
  .iconleft {
    width: 1.57rem;
    height: 3.83rem;
    position: absolute;
    bottom: 20%;
    background: url("../images/team2.png") no-repeat;
    background-size: contain;
    left: 0;
  }
  .iconright {
    width: 1.57rem;
    height: 3.83rem;
    position: absolute;
    bottom: 20%;
    background: url("../images/team1.png") no-repeat;
    background-size: contain;
    right: 0;
  }
  .head {
    width: 3.24rem;
    border-bottom: 1px solid rgba(51, 51, 51, 0.25);
    padding-bottom: 0.13rem;
    margin: 0.4rem auto 0;
    h4 {
      font-size: 0.36rem;
      font-family: PingFang SC;
      font-weight: 600;
      color: #333333;
      opacity: 0.9;
      text-align: center;
    }
  }
  .box {
    width: 100%;
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-justify-content: space-between;
    -moz-justify-content: space-between;
    -ms-justify-content: space-between;
    -o-justify-content: space-between;
    justify-content: space-between;
    -webkit-box-pack: space-between;
    -webkit-flex-wrap: wrap;
    -moz-flex-wrap: wrap;
    -ms-flex-wrap: wrap;
    -o-flex-wrap: wrap;
    flex-wrap: wrap;
    box-sizing: border-box;
    overflow: hidden;
    padding: 0 0.36rem 1rem;
    margin-top: 0.75rem;
  }
}
.item1 {
  background-size: 2.46rem 0.99rem;
}
.item2 {
  background-size: 1.9rem 0.62rem;
}
.item3 {
  background-size: 1.88rem 0.8rem;
}
.item4 {
  background-size: 1.86rem 0.53rem;
}
.item5 {
  background-size: 1.35rem 1.36rem;
}
.item6 {
  background-size: 1.91rem 1.9rem;
}
.item7 {
  background-size: 2.01rem 0.58rem;
}

.item8 {
  background-size: 1.5rem 0.38rem;
}
.item9 {
  background-size: 1.91rem 0.44rem;
}
.item10 {
  background-size: 1.15rem 0.97rem;
}
.item11 {
  background-size: 0.92rem 0.92rem;
}
.item12 {
  background-size: 1.92rem 0.4rem;
}
.item13 {
  background-size: 0.92rem 1.02rem;
}
.item14 {
  background-size: 1.52rem 0.47rem;
}
.item15 {
  background-size: 1.8rem 0.41rem;
}
.item16 {
  background-size: 1.72rem 0.62rem;
}
.item17 {
  background-size: 1.69rem 0.68rem;
}
.item18 {
  background-size: 1.69rem 0.4225rem;
}
.item19 {
  background-size: 0.92rem 0.92rem;
}
.item20 {
  background-size: 0.92rem 0.92rem;
}
.item21 {
  background-size: 2.05rem 0.58rem;
}
.item22 {
  background-size: 1.5rem 1.5rem;
}

.item {
  cursor: pointer;
  width: 3.22rem;
  height: 2.22rem;
  margin-top: 0.32rem;
  background-color: rgba(255, 255, 255, 1);
  background-repeat: no-repeat;
  background-position: center center;
  box-shadow: 0.03rem 0.04rem 0.21rem 0 rgba(70, 214, 177, 0.24);
  border-radius: 0.15rem;
  position: relative;
  overflow: hidden;

  .active {
    opacity: 1;
    top: 0 !important;
    transition: 0.5s all ease;
  }
  .mask {
    opacity: 1;
    width: 100%;
    height: 100%;
    background: rgba(255, 106, 0, 0.72);
    box-shadow: 0.03rem 0.04rem 0.21rem 0 rgba(70, 214, 177, 0.24);
    border-radius: 0.15rem;
    position: absolute;
    top: 100%;
    left: 0;
    z-index: 10;
    box-sizing: border-box;
    padding: 0.2rem 0.15rem 0;
    h4 {
      font-size: 0.24rem;
      text-align: center;
      color: rgba(255, 255, 255, 1);
      margin-bottom: 0.1rem;
    }
    p {
      font-size: 0.16rem;
      text-align: center;
      color: rgba(255, 255, 255, 1);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/h5/family.vue